import { Link, useLocation } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

const routeLabels = {
  'dashboard': 'Dashboard',
  'accounts': 'Accounts',
  'trial-balance': 'Trial Balance',
  'balance-sheet': 'Balance Sheet',
  'income-statement': 'Income Statement',
  'mda': 'MD&A',
  'automated-reports': 'Automated Reports',
  'analytics': 'Analytics',
  'financial-analytics': 'Financial Analytics',
  'predictive-analytics': 'Predictive Analytics',
  'fpa': 'FP&A',
  'reconciliations': 'Reconciliations',
  'workpapers': 'Work Papers',
  'audit-trail': 'Audit Trail',
  'import': 'Import Data',
  'templates': 'ERP Templates',
  'cloud-storage': 'Cloud Storage',
  'users': 'User Management',
  'settings': 'Settings',
  'faq': 'FAQ & Help',
  'search': 'Search'
};

export default function Breadcrumbs() {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);

  if (pathnames.length === 0 || pathnames[0] === 'dashboard') {
    return null; // Don't show breadcrumbs on dashboard
  }

  return (
    <nav className="flex items-center space-x-2 text-sm text-muted-foreground mb-6">
      <Link
        to="/dashboard"
        className="flex items-center hover:text-foreground transition-colors"
      >
        <Home className="w-4 h-4" />
      </Link>
      
      {pathnames.map((value, index) => {
        const to = `/${pathnames.slice(0, index + 1).join('/')}`;
        const isLast = index === pathnames.length - 1;
        const label = routeLabels[value] || value.charAt(0).toUpperCase() + value.slice(1);

        return (
          <div key={to} className="flex items-center space-x-2">
            <ChevronRight className="w-4 h-4" />
            {isLast ? (
              <span className="font-medium text-foreground">{label}</span>
            ) : (
              <Link
                to={to}
                className="hover:text-foreground transition-colors"
              >
                {label}
              </Link>
            )}
          </div>
        );
      })}
    </nav>
  );
}
